/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-footer/centered-logo-menu-footer/centered-logo-menu-footer.component.scss */
/*# sourceMappingURL=centered-logo-menu-footer.component.css.map */
